{
  "title": "Buzones",
  "subtitle": "Buzones reflejados desde el directorio y la firma que recibe cada uno.",
  "listIntro": "Reflejados desde el directorio del cliente. Las personas aparecen aquí automáticamente en unos quince minutos tras crearse en Microsoft 365.",
  "searchPlaceholder": "Buscar nombre o dirección",
  "defaultTemplate": "Firma predeterminada",
  "defaultIntro": "Se aplica a cada buzón que no tenga algo más específico. Las reglas del operador y las firmas de grupo la anulan; una firma establecida en una persona aquí anula ambas.",
  "noPublishedTemplates": "Aún no hay plantillas publicadas. Publique una en la pestaña Firmas y podrá convertirse en la predeterminada del inquilino.",
  "newMessages": "Mensajes nuevos",
  "noDefault": "Sin predeterminada",
  "repliesForwards": "Respuestas y reenvíos",
  "sameAsNew": "Igual que mensajes nuevos",
  "saveDefault": "Guardar predeterminada",
  "defaultCleared": "Predeterminada borrada. Los buzones que la seguían ya no se estampan.",
  "defaultSaved": "Predeterminada guardada y aplicada a todos los buzones.",
  "saveFailed": "No se pudo guardar.",
  "noMailboxesCovered": "Aún no hay buzones cubiertos.",
  "coveredCount": "{{count}} buzón cubierto.",
  "coveredCount_other": "{{count}} buzones cubiertos.",
  "coveredWithCustom": "{{covered}} buzones cubiertos, {{custom}} con una firma establecida individualmente.",
  "setDefault": "Establecer predeterminada",
  "colPerson": "Persona",
  "colSignature": "Firma",
  "colNewMessages": "Mensajes nuevos",
  "colRepliesForwards": "Respuestas y reenvíos",
  "previewNewAria": "Vista previa de la firma para mensajes nuevos {{name}}",
  "previewReplyAria": "Vista previa de la firma de respuesta {{name}}",
  "colStamped": "Estampado",
  "colSidebar": "Panel lateral",
  "colAllowChanges": "Permitir cambios",
  "colExcluded": "Excluido",
  "selectAllVisible": "Seleccionar todos los buzones visibles",
  "selectUser": "Seleccionar {{email}}",
  "emptySearch": "Nadie coincide con esa búsqueda.",
  "emptyNone": "Aún no se han sincronizado buzones. Conecte un directorio en la pestaña Configuración.",
  "showingFirst200": "Mostrando los primeros 200. Busque para acotar la lista.",
  "addressesCount": "{{count}} direcciones",
  "noMailbox": "Sin buzón",
  "stateCustomised": "Personalizado",
  "stateDefault": "Predeterminado",
  "stateNotCovered": "No cubierto",
  "stateCustom": "Personalizado",
  "stateExcluded": "Excluido",
  "stateRule": "Desde regla",
  "stateGroup": "Desde grupo",
  "previewAria": "Vista previa de la firma {{name}}",
  "stampAria": "Estampar correo de {{email}}",
  "sidebarAria": "Ofrecer panel lateral de Outlook para {{email}}",
  "sidebarTitle": "Ofrecer el panel de firma de Outlook a esta persona",
  "allowChangesAria": "Permitir cambios de firma para {{email}}",
  "allowChangesTitle": "Permitirles elegir una firma y editar campos en Outlook",
  "changeFailed": "No se pudo cambiar.",
  "preview": "Vista previa",
  "whyThis": "¿Por qué esta?",
  "fields": "Campos",
  "customise": "Personalizar",
  "revert": "Revertir",
  "revertedToDefault": "{{name}} vuelve a la predeterminada del inquilino.",
  "unknownTemplate": "Plantilla desconocida",
  "signatureFallback": "Firma",
  "massUpdate": "Actualización masiva",
  "massUpdateCount": "Actualización masiva ({{count}})",
  "selectedCount": "{{count}} seleccionados",
  "massUpdateTitle": "Actualización masiva",
  "massUpdateIntro": "Aplicar un cambio a {{count}} buzón seleccionado.",
  "massUpdateIntro_other": "Aplicar un cambio a {{count}} buzones seleccionados.",
  "action": "Acción",
  "actionPlaceholder": "Elija qué cambiar",
  "actionStamp": "Estampar (incluir en firmas)",
  "actionUnstamp": "Quitar estampado (excluir de firmas)",
  "actionCustomise": "Personalizar firma",
  "actionRevert": "Revertir a la predeterminada del inquilino",
  "actionSidebarOn": "Panel lateral de Outlook: habilitar",
  "actionSidebarOff": "Panel lateral de Outlook: deshabilitar",
  "actionAllowOn": "Outlook: permitir cambios",
  "actionAllowOff": "Outlook: bloquear ajustes (solo vista previa)",
  "signature": "Firma",
  "choosePublished": "Elegir una plantilla publicada",
  "skippedNoMailbox": "{{count}} sin buzón se omitirán.",
  "skippedNotCustomised": "{{count}} no personalizados se omitirán.",
  "nobodyEligible": "Nadie en la selección puede recibir ese cambio.",
  "apply": "Aplicar",
  "updatedCount": "Se actualizó {{count}} buzón.",
  "updatedCount_other": "Se actualizaron {{count}} buzones.",
  "failedCount": "No se pudo actualizar {{count}} buzón.",
  "failedCount_other": "No se pudieron actualizar {{count}} buzones.",
  "partialUpdate": "Actualizados {{succeeded}}, fallaron {{failed}}.",
  "massUpdateFailed": "No se pudo aplicar esa actualización masiva.",
  "customiseTitle": "Firma de {{name}}",
  "customiseIntro": "Esto fija un buzón a una firma propia. Tiene prioridad sobre las reglas de grupo y la predeterminada del inquilino, y deja de seguir la predeterminada, incluso si esta cambia después.",
  "setSignature": "Establecer firma",
  "customiseSuccess": "{{name}} ahora tiene su propia firma.",
  "customiseFailed": "No se pudo establecer esa firma.",
  "explainTitle": "Firma de {{name}}",
  "explainIntro": "Ejecuta la misma evaluación que el recorrido del correo, frente a un mensaje nuevo a un destinatario externo.",
  "explain": "Explicar",
  "explainFailedTitle": "No se pudo ejecutar la prueba",
  "fieldsTitle": "Campos — {{name}}",
  "fieldsSaved": "Sobrescrituras de campos guardadas.",
  "fieldsSaveFailed": "No se pudo guardar.",
  "photoAria": "Foto de {{email}}",
  "photoUploaded": "Foto cargada",
  "photoFromDirectory": "Desde el directorio",
  "uploadPhoto": "Cargar una foto",
  "replacePhoto": "Reemplazar foto",
  "clearPhoto": "Borrar foto",
  "removeUseDirectory": "Quitar y usar la del directorio",
  "photoRemoved": "Foto eliminada. La próxima sincronización del directorio devolverá la suya si tiene una.",
  "photoNotRemovedTitle": "No eliminada",
  "photoNotRemoved": "No se pudo eliminar esa foto.",
  "photoUpdated": "Foto actualizada.",
  "photoUpdatedTitle": "Foto actualizada",
  "photoNotUploadedTitle": "No cargada",
  "photoNotUploaded": "No se pudo cargar esa foto.",
  "photo": "Foto",
  "exclude": "Excluir del estampado",
  "include": "Incluir en el estampado",
  "editFields": "Editar campos",
  "outlookSetup": "Configuración del complemento de Outlook",
  "outlook": {
    "cardTitle": "Complemento del panel lateral de Outlook",
    "cardIntro": "Implemente el complemento una vez mediante Microsoft 365 Centralized Deployment y luego habilítelo por buzón en la pestaña Usuarios. Los valores predeterminados siguientes solo se aplican a los buzones recién sincronizados.",
    "setupWizard": "Asistente de configuración",
    "sidebarDefault": "Habilitar panel lateral para buzones nuevos",
    "allowDefault": "Permitir cambios de autoservicio para buzones nuevos",
    "editableFields": "Campos que los usuarios finales pueden editar",
    "editableFieldsDesc": "p. ej. móvil, cargo. Los campos de identidad nunca son editables.",
    "fieldPlaceholder": "Añadir una clave de campo de combinación",
    "manifestUrl": "URL del manifiesto",
    "manifestCopied": "URL del manifiesto copiada.",
    "save": "Guardar ajustes de Outlook",
    "saved": "Ajustes del panel lateral de Outlook guardados.",
    "saveFailed": "No se pudo guardar.",
    "gateNote": "Los interruptores Sidebar / Permitir cambios por buzón en la pestaña Usuarios controlan el acceso tras la implementación.",
    "wizardTitle": "Implementar el complemento de firma de Outlook",
    "wizardIntro": "Centralized Deployment instala el complemento para los usuarios de Microsoft 365 asignados. Después, active Sidebar (y opcionalmente Permitir cambios) por buzón en la pestaña Usuarios: la implementación sola no abre los ajustes para todos.",
    "stepPrereq": "Requisitos previos",
    "stepManifest": "URL del manifiesto",
    "stepUpload": "Cargar en el centro de administración",
    "stepAssign": "Asignar usuarios",
    "stepEnable": "Habilitar buzones",
    "stepVerify": "Verificar en Outlook",
    "completeTitle": "Lista de comprobación de implementación completa",
    "completeBody": "Es posible que los usuarios deban reiniciar Outlook. El botón de la cinta puede tardar hasta unas horas en aparecer para todos. Si el panel indica que la organización no ha habilitado los ajustes de firma, active Sidebar para ese buzón en Usuarios.",
    "finish": "Finalizar",
    "beforeStart": "Antes de empezar",
    "prereqAdmin": "Inicie sesión en el centro de administración de Microsoft 365 como administrador global o administrador de aplicaciones de Office.",
    "prereqOutlook": "Los usuarios necesitan Exchange Online / Microsoft 365 Outlook (Outlook clásico perpetuo no es compatible con este complemento).",
    "prereqHttps": "El manifiesto XML solo del complemento lo aloja OnBrandMail por HTTPS: pegue la URL; no cargue un archivo desde el disco.",
    "copyManifestTitle": "Copiar la URL del manifiesto",
    "copyManifestBody": "Microsoft valida este enlace XML al implementar. Manténgalo en HTTPS y no reescriba la ruta (debe terminar en manifest.xml).",
    "uploadTitle": "Cargar en el centro de administración de Microsoft 365",
    "uploadStep1": "Abra Configuración → Aplicaciones integradas en el centro de administración.",
    "uploadStep2": "Elija Cargar aplicaciones personalizadas (o Implementar complemento si está en la página de complementos).",
    "uploadStep3": "Establezca el tipo de aplicación en Complemento de Office (no aplicación de Teams).",
    "uploadStep4": "Seleccione Proporcionar vínculo al archivo de manifiesto, pegue la URL XML del paso anterior y luego Validar / Cargar.",
    "uploadStep5": "Acepte las solicitudes de permisos cuando se le indiquen para que Outlook pueda abrir el panel de firma.",
    "openIntegratedApps": "Abrir Aplicaciones integradas",
    "pilotHint": "Prefiera primero un grupo de seguridad piloto (las mismas personas que usa para el piloto de flujo de correo). Puede ampliar la asignación más adelante sin volver a cargar el manifiesto.",
    "assignTitle": "Quién recibe el complemento",
    "assignIntro": "La asignación aquí solo instala el botón de Outlook. No concede autoservicio de firmas: eso permanece en la pestaña Usuarios.",
    "assignSpecific": "Usuarios/grupos específicos — recomendado. Empiece con su grupo piloto de OnBrandMail.",
    "assignEveryone": "Todos — adecuado cuando esté listo; el panel sigue mostrando un estado vacío hasta que Sidebar esté habilitado para ese buzón.",
    "assignJustMe": "Solo yo — útil para validar la cinta antes de ampliar el despliegue.",
    "assignDeploy": "Seleccione Implementar / Finalizar implementación cuando el asistente lo pida. Microsoft puede tardar minutos u horas antes de que el botón aparezca para cada asignado.",
    "enableTitle": "Habilitar buzones en OnBrandMail",
    "enableIntro": "Centralized Deployment es de alcance organizativo; OnBrandMail controla la experiencia por persona.",
    "enableStep1": "Abra la pestaña Usuarios de este inquilino.",
    "enableStep2": "Active Sidebar para cada buzón piloto (o use Actualización masiva → Panel lateral de Outlook: habilitar).",
    "enableStep3": "Opcionalmente active Permitir cambios para que esas personas puedan elegir una plantilla y editar campos gobernados. Déjelo desactivado solo para vista previa.",
    "enableStep4": "Los administradores del inquilino siempre obtienen el panel elevado para su propio buzón, aunque Sidebar esté desactivado.",
    "enableDefaultsNote": "Los valores predeterminados de esta tarjeta de Configuración solo se aplican a buzones recién sincronizados. Las personas existentes necesitan los interruptores de Usuarios (o la actualización masiva).",
    "verifyTitle": "Verificar en Outlook",
    "verifyStep1": "Reinicie el nuevo Outlook / Outlook en la web para un usuario piloto.",
    "verifyStep2": "Abra un mensaje o una ventana de redacción y busque el botón Firma en la cinta.",
    "verifyStep3": "El panel debería mostrar su vista previa y «por qué esta firma». Si los ajustes están bloqueados, es lo esperado cuando Permitir cambios está desactivado.",
    "verifyStep4": "Como administrador del inquilino, confirme que la franja de administración y la búsqueda de buzones aparecen al abrir el panel usted mismo.",
    "verifyManifestHint": "Si la validación de la URL del manifiesto falla en el centro de administración, confirme que la URL devuelve XML (OfficeApp) por HTTPS desde un navegador fuera de su red.",
    "theUrl": "la URL"
  }
}
